import script from "./FloatContact.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatContact.vue?vue&type=script&setup=true&lang=js"

import "./FloatContact.vue?vue&type=style&index=0&id=30a4d19d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30a4d19d"]])

export default __exports__